<template>
  <div class="dep-info research">
    <header>
      <topbar />
      <navbar v-show="isMobile !== true" />
      <mobile-nav v-show="isMobile" />
      <section-header text="std_graguate.studentsGraguate" />
    </header>
    <main>
      <section class="tracking-body">
          <div class="container-center">
            <div class="tracking-headertext">{{ $t("students.alumni") }}</div>
          </div>
          <div class="container-center">
            <div class="custom-input">
            <input type="text" v-model="title" placeholder="ابحث عن الخريج ....">
          </div>
          </div>
        </section>
      <section class="section-deps">
        <b-container>
          <section data-aos="fade-left" class="section section-lessons">
            <h3>
              {{ $t("std_graguate.studentsGraguate") }}
            </h3>
            <div>
              <div class="tbl-header">
                <table cellpadding="0" cellspacing="0" border="0">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>{{ $t("studentResearch.name") }}</th>
                      <th>{{ $t("studentResearch.year") }}</th>
                      <th>{{ $t("studentResearch.dep") }}</th>
                      <th>{{ $t("studentResearch.title") }}</th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="tbl-content">
                <table cellpadding="0" cellspacing="0" border="0">
                  <tbody>
                    <tr
                      v-for="(research, index) in installments"
                      :key="research.id"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>{{ research.name }}</td>
                      <td>{{ research.year }}</td>
                      <td>{{ research.depatrment.name }}</td>
                      <td>{{ research.dwor }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </b-container>
      </section>
      <b-container>
        <b-row>
          <b-col class="d-flex justify-content-center mb-5">
            <b-pagination
              size="lg"
              v-model="currentPage"
              :total-rows="totalCount"
              :per-page="perPage"
              class="mx-auto"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-container>
    </main>
    <footer>
      <footer-component />
    </footer>
  </div>
</template>

<script>
// import { filesUrl } from "@/main";
import { mapState } from "vuex";
import MobileNav from "@/components/layout/MobileNav.component.vue";
import Topbar from "@/components/layout/Topbar.component.vue";
import Navbar from "@/components/layout/Navbar.component.vue";
import SectionHeader from "@/components/layout/SectionHeader.component.vue";
import FooterComponent from "@/components/layout/FooterComponent.component.vue";

export default {
  components: {
    Topbar,
    Navbar,
    SectionHeader,
    FooterComponent,
    MobileNav,
  },
  data() {
    return {
      installments: null,
      totalInstallment: 0,
      isMobile: false,
      perPage: 10,
      currentPage: 1,
      totalCount: "",
      title:""
    };
  },
  computed: { ...mapState(["depId"]) },
  watch: {
    depId: async function () {
      this.getResearches();
    },
    currentPage: {
      handler: function () {
        this.getResearches();
      },
    },
    title: {
      handler: function () {
        this.getResearches();
      },
    },
  },
  async mounted() {
    if(localStorage.getItem("lang")=="en"){
    document.title = ` Al-Nisour University   - Student Researches`;
    document.querySelector('meta[name="title"]').setAttribute("content","Student Researches");
    document.querySelector('meta[name="description"]').setAttribute("content", "");
    document.querySelector('meta[property="og:title"]').setAttribute("content","Student Researches");
    document.querySelector('meta[property="og:description"]').setAttribute("content", "");
    }else{
    document.title = `جامعة النسور  - بحوث الطلبة المتخرجين`;
    document.querySelector('meta[name="title"]').setAttribute("content","بحوث الطلبة المتخرجين");
    document.querySelector('meta[name="description"]').setAttribute("content", "");
    document.querySelector('meta[property="og:title"]').setAttribute("content","بحوث الطلبة المتخرجين");
    document.querySelector('meta[property="og:description"]').setAttribute("content", "");
    }
    document.querySelector('meta[property="og:image"]').setAttribute("content", `https://e-learn.nuc.edu.iq/images/logo.png`);
    // document.getElementById("icon").setAttribute("href",`${filesUrl}favicon.ico`); 
    if (window.innerWidth > 991) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
    this.getResearches();
  },
  methods: {
    getResearches() {
      let skip = this.currentPage - 1;
      this.axios
        .get(
          `students/graguated/clint?skip=${skip}&take=${this.perPage}&department=${this.$route.params.id}&title=${this.title}`
        )
        .then((res) => {
          this.installments = res.data.items;
          this.totalCount = res.data.totalCount;
        });
    },
  },
};
</script>
